import { useCurrentUser } from "@/features/auth";

// Хайлайты открыты команде и подписчикам Pro (03.11.2026: платная функция) — решает бэкенд
// (`highlights.services.highlights_allowed`) и отдаёт в `GET /api/me` (`highlights`).
// Остальным нет ни пункта меню, ни блоков, ни запросов — бэкенд им отвечает 403.
export const useHighlightsAllowed = () => useCurrentUser().data?.highlights === true;
